var _SingleInvokeEvent_fired, _SingleInvokeEvent_sender, _SingleInvokeEvent_args;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Event from "./Event";
/**
 * An event type that can only be invoked once. Once the event
 * is invoked, and handler that is added to it will be immediately
 * executed. All subsequent invocations are ignored
 */
export default class SingleInvokeEvent extends Event {
    /**
     * Create a new singly invokable event.
     */
    constructor() {
        super();
        /** event has been fired */
        _SingleInvokeEvent_fired.set(this, void 0);
        /** the firing sender */
        _SingleInvokeEvent_sender.set(this, void 0);
        /** the firing args */
        _SingleInvokeEvent_args.set(this, void 0);
        __classPrivateFieldSet(this, _SingleInvokeEvent_fired, false, "f");
    }
    // Add a handler to the event
    addHandler(eventHandler) {
        super.addHandler(eventHandler);
        if (__classPrivateFieldGet(this, _SingleInvokeEvent_fired, "f")) {
            eventHandler.call(__classPrivateFieldGet(this, _SingleInvokeEvent_sender, "f"), __classPrivateFieldGet(this, _SingleInvokeEvent_sender, "f"), __classPrivateFieldGet(this, _SingleInvokeEvent_args, "f"));
        }
        return eventHandler;
    }
    // invoke the event
    invoke(sender, args) {
        /// <signature>
        /// <summary>Invoke the event handlers</summary>
        /// <param type='Object' name='sender'>The object that raised/owns the event</param>
        /// <param type='Object' name='sender'>Any to be passed as arguments to the handlers</param>
        /// </signature>
        if (__classPrivateFieldGet(this, _SingleInvokeEvent_fired, "f")) {
            return;
        }
        __classPrivateFieldSet(this, _SingleInvokeEvent_fired, true, "f");
        __classPrivateFieldSet(this, _SingleInvokeEvent_sender, sender, "f");
        __classPrivateFieldSet(this, _SingleInvokeEvent_args, args, "f");
        super.invoke(sender, args);
    }
}
_SingleInvokeEvent_fired = new WeakMap(), _SingleInvokeEvent_sender = new WeakMap(), _SingleInvokeEvent_args = new WeakMap();
